import ItnAPI from './_integrationApi.js';
import httpClient from '@/apis/base/httpclient';

class IntegrationNPSApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'NPSSurveys';

  getSurvey() {
    let request = {
      url: this.getAPIUrl(),
    };
    return this.getAsync(request);
  }

  /**
   * Kiểm tra điều kiện và show khảo sát
   * @param {*} param
   * @returns
   * dqvinh 3/2/2023
   */
  checkSurvey() {
    let request = {
      url: this.getAPIUrl() + '/checkSurvey',
    };
    return this.getAsync(request);
  }
  /**
   * Hàm lưu lại thông tin sau khi khảo sát
   * @param {*} param
   * @returns
   */
  saveSurveyResult(param) {
    let request = {
      url: this.getAPIUrl() + '/saveSurveyResult',
      data: param,
    };
    return this.postAsync(request);
  }


   /**
   * Hàm lưu lại số lần người dùng đóng form (lưu về db bên mình để check nếu quá 3 lần thì không hiển thị lại nữa)
   * @param {*} param
   * @returns
   */
    updateCancelCount(param) {
      let request = {
        url: this.getAPIUrl() + '/updateCancelCount',
        data: param,
      };
      return this.postAsync(request);
    }
}
export default new IntegrationNPSApi();
